import React from "react";
import { Step } from "semantic-ui-react";

export type MultiStepEditSectionStep = {
  title: string
  isActive: boolean
}

export interface MultiStepEditSectionSteps {
  steps: MultiStepEditSectionStep[]
  onNext: () => void
  onPrev: () => void
}

export const MultiStepEditSectionSteps = (props: MultiStepEditSectionSteps) => {
  // Find the index of current step
  const currentStepIndex = props.steps.findIndex(s => s.isActive);

  const isStepClickable = (index) => {
    // Only the next and previous steps are active
    return index === currentStepIndex - 1 ||
      index === currentStepIndex + 1;
  }

  const onClick = (index) => {
    if (index === currentStepIndex + 1) {
      props.onNext();
    } else if (index === currentStepIndex - 1) {
      props.onPrev();
    }
  }

  // We need to use 'as any' becauase semantic ui react defines widths as 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8, which is very weird
  return <div>
    <Step.Group widths={props.steps.length as any}>
      {props.steps.map((s, index) => <Step key={s.title} onClick={() => onClick(index)} active={s.isActive} disabled={!isStepClickable(index)}>
        <Step.Content>
          <Step.Title>{s.title}</Step.Title>
        </Step.Content>
      </Step>)}
    </Step.Group>
  </div>
}